import { LotParams } from 'src/domain/lot'
import { LotDto } from 'src/dto/lot.dto'
import { LotService } from 'src/services/api/lot.service'
export class LotController {
  private service: LotService

  constructor() {
    this.service = new LotService()
  }

  public async getLotListByFarmId(farmId: string): Promise<LotDto[]> {
    const response = await this.service.getLotListByFarmId(farmId)
    const lotList = response.data.filter((item) => item.idFazenda === farmId)
    const dataOrdered = lotList.sort((a: LotDto, b: LotDto) => a.descricao!.localeCompare(b.descricao!))
    return dataOrdered
  }

  public async updateLot(farmId: string, updateLotDto: LotParams): Promise<LotDto> {
    const response = await this.service.updateLote(farmId, updateLotDto)
    return response.data
  }
}
